import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import Box from '@material-ui/core/Box';
import { Container, Grid, Paper, MenuItem, Typography, Button } from '@material-ui/core';
import { GetLocation as GET_LOCATION } from 'Components/Api/PaysprintAEPSAPI';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import usePosition from 'Components/Posistion';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { SelectBankList as BANK_LIST } from 'Components/Api/PaysprintDMTAPI';
import { GetLocationName as GET_LOCATION_Name } from 'Components/Api/GetLocationNameAPI';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from 'react-router-dom';

const CustomContainer = HOCLoader(Container);

export const PaysprintAEPSGetLocation = () => {
    const history = useHistory();
    const formRef = useRef();
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [Message, setMessage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const Mobile = localStorage.getItem('MobileNumber');
    const MerchantCode = localStorage.getItem('PaysprintAEPSAgentID');
    const [Pipe, setPipe] = useState([]);
    const [Name, setName] = useState([]);
    const { latitude, longitude, error } = usePosition();
    const location = useLocation();
    const Lat = location?.state?.Lat;
    const Long = location?.state?.Long;

    const [formObj, setFormObj] = useState({
        MobileNumber: Mobile,
        Pipe: '',
        Latitude: latitude,
        Longitude: longitude
    });

    const validationSchema = Yup.object({
        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number')
    });

    const SubmitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setResponseMessage('');
        setLoadingOpen(true);

        var request = {
            MerchantCode: MerchantCode,
            MobileNumber: values.MobileNumber,
            Pipe: values.Pipe,
            Latitude: latitude,
            Longitude: longitude,
            Mode: 'WEB'
        };
        var requestObj = JSON.stringify(request);

        var response = await GET_LOCATION(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        let data = JSON.parse(response.data);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(data.Message);
        setMessage(data);
        history.push('/PSAEPS');
    };
    const GetPipeList = async () => {
        var request = {
            ID: 0
        };
        var json = JSON.stringify(request);

        const response = await BANK_LIST(json);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setPipe(data);
        setFormObj({
            ...formObj,
            Pipe: data[0].BankName
        });
    };

    const GetLocationByName = async () => {
        var request = {
            Latitude: Lat,
            Longitude: Long,
        };
        var requestObj = JSON.stringify(request);
        var response = await GET_LOCATION_Name(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        let data = JSON.parse(response.data);
        setName(data.Message);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(data.Message);
        setMessage(data);
    };

    useEffect(() => {
        GetPipeList();
        GetLocationByName();
    }, []);

    const PipeList = Pipe.map((item) => (
        <MenuItem key={item.ID} value={item.BankName}>
            {item.BankName}
        </MenuItem>
    ));

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={SubmitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            yarn
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                            style={{ justifyContent: 'center' }}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>

                                <h2 className={classes.PaperHead_h2}>
                                    Geo Code Mapping
                                </h2>
                                <Grid item xs={12}>
                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Merchant Code
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {MerchantCode}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Mobile Number
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {Mobile}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Latitude
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {latitude}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Longitude
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {longitude}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Address
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {Name}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box style={{ flexDirection: 'row', display: 'flex', }}>
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', width: '50%' }}>
                                                        Access Mode
                                                    </Typography>
                                                    <Typography variant="body1" style={{ width: '50%' }}>
                                                        {"WEB"}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialSelect
                                                    label="Pipe"
                                                    name="Pipe"
                                                    title="Select Bank Type"
                                                >
                                                    {PipeList}
                                                </MaterialSelect>
                                            </Grid>


                                        </Grid>
                                    </Paper>
                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit();
                                                    }}
                                                    disabled={loadingOpen}
                                                >
                                                    Proceed
                                                </Button>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Cancel
                                            </Button>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
